import { render, staticRenderFns } from "./HolidaysTableRow.vue?vue&type=template&id=2b772ff2&scoped=true"
import script from "./HolidaysTableRow.vue?vue&type=script&lang=js"
export * from "./HolidaysTableRow.vue?vue&type=script&lang=js"
import style0 from "./HolidaysTableRow.vue?vue&type=style&index=0&id=2b772ff2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b772ff2",
  null
  
)

export default component.exports